export const defaultPlayerActionTimeQuickPlay = 60 // 1 minute
export const defaultPlayerActionTimeTournament = 30 // 30 seconds

export class Timing {
  /**
   *
   * @returns UTC Now in Milliseconds
   */
  static getUtcMsNow() {
    const checktime = new Date()
    // return checktime.getTime() + checktime.getTimezoneOffset() * 60 * 1000
    return checktime.getTime()
  }

  static over10SecondsAgo(utcms: number) {
    return Timing.overXSecondsAgo(utcms, 10)
  }

  static over20SecondsAgo(utcms: number) {
    return Timing.overXSecondsAgo(utcms, 20)
  }

  static over30SecondsAgo(utcms: number) {
    return Timing.overXSecondsAgo(utcms, 30)
  }

  static overAMinuteAgo(utcms: number) {
    return Timing.overXSecondsAgo(utcms, 60)
  }

  static overXSecondsAgo(utcms: number, secs: number) {
    return Timing.getUtcMsNow() - secs * 1000 > utcms
  }
}
